<template>
    <TableProjectManagementSheetInvetory></TableProjectManagementSheetInvetory>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);

const TableProjectManagementSheetInvetory = defineAsyncComponent(() =>
    import(
        "../../components/ProjectManagement/MaterialSheetInventory/Table.vue"
    )
);

export default {
    name: "Project_Management_Sheet_Inv",
    components: { TableProjectManagementSheetInvetory, AuthLayout },
};
</script>
